import { startError } from "../../error";

export const handleError = (): void => startError();
